var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.667 22.333H7.33301V5.66699H16.417L20.667 9.91699V22.333ZM15.542 10.792H18.917L15.542 7.41699V10.792ZM14 19.833C14.9587 19.833 15.7817 19.4893 16.469 18.802C17.1563 18.1147 17.5 17.2917 17.5 16.333V13.354H15.75V16.333C15.75 16.819 15.58 17.2323 15.24 17.573C14.8993 17.913 14.486 18.083 14 18.083C13.514 18.083 13.1007 17.913 12.76 17.573C12.42 17.2323 12.25 16.819 12.25 16.333V12.021C12.25 11.8957 12.2917 11.7913 12.375 11.708C12.4583 11.6247 12.5627 11.583 12.688 11.583C12.8127 11.583 12.9167 11.6247 13 11.708C13.0833 11.7913 13.125 11.8957 13.125 12.021V16.333H14.875V12.021C14.875 11.4097 14.6633 10.8923 14.24 10.469C13.816 10.045 13.2987 9.83299 12.688 9.83299C12.0767 9.83299 11.559 10.045 11.135 10.469C10.7117 10.8923 10.5 11.4097 10.5 12.021V16.333C10.5 17.2917 10.8437 18.1147 11.531 18.802C12.2183 19.4893 13.0413 19.833 14 19.833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.e4f526c3fe7a491e1d1daea156a776fb.svg";
export { ForwardRef as ReactComponent };